export const second = 1000; //milliseconds
export const minute = second * 60; //milliseconds
export interface ITimes {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
}
